import { TwilioMessageModel } from "@jugl-web/rest-api";
import { apiUTCToLocalDateTime } from "@jugl-web/utils";
import { isSameDay } from "date-fns";
import React, { useMemo } from "react";
import { TwilioMessageBubble } from "../TwilioMessageBubble";
import { CRMInfoMessage } from "../CRMInfoMessage";

export const TwilioMessageItem: React.FC<{
  message: TwilioMessageModel;
  messages: TwilioMessageModel[];
}> = ({ message, messages }) => {
  const groupInfo = useMemo(() => {
    const idx = messages.findIndex((item) => item.msg_id === message.msg_id);

    const result = {
      isFirst: false,
      isLast: false,
    };
    const prevMessage = messages[idx - 1];
    const nextMessage = messages[idx + 1];
    if (
      !prevMessage ||
      prevMessage?.from !== message.from ||
      prevMessage?.type === "info" ||
      prevMessage?.auto_response !== message.auto_response ||
      !isSameDay(
        apiUTCToLocalDateTime(prevMessage.payload.timestamp),
        apiUTCToLocalDateTime(message.payload.timestamp)
      )
    ) {
      result.isFirst = true;
    }
    if (
      !nextMessage ||
      nextMessage?.from !== message.from ||
      nextMessage?.type === "info" ||
      nextMessage.auto_response !== message.auto_response
    ) {
      result.isLast = true;
    }

    return result;
  }, [message, messages]);

  const $content = useMemo(() => {
    if (message.type === "info") {
      return (
        <CRMInfoMessage
          message={message.payload.text}
          timestamp={message.payload.timestamp}
        />
      );
    }

    return <TwilioMessageBubble message={message} groupInfo={groupInfo} />;
  }, [groupInfo, message]);

  return $content;
};
